export default __webpack_public_path__ + "static/media/red-hdb-block.ad6b0ba9.svg";